import { Link } from "gatsby"
import React, { useState } from "react"

const Photo = photo => {
  const [isVisible, setIsVisible] = useState(false)

  const { img, title, description, projectNumber, photos } = photo

  return (
    <section className="flex justify-end mx-3 md:mx-0">
      <div className="self-center mr-4 md:mr-[40px]">
        <h1 className="vertical-text m-0 font-playfair font-black text-2xl text-black md:text-[36px]">
          {title}
        </h1>
      </div>
      <Link to={title.toLowerCase()}>
        <div
          onMouseEnter={() => setIsVisible(true)}
          onMouseLeave={() => setIsVisible(false)}
          onTouchStart={() => setIsVisible(true)}
          onTouchEnd={() => setIsVisible(false)}
          className="relative cursor-pointer"
          role="button"
          tabIndex="0"
        >
          <img className="m-0 mb-[20px]" src={img} alt={title} />
          <div
            className={`absolute flex items-center w-full ${
              isVisible
                ? "bg-black bg-opacity-80"
                : "bg-transparent opacity-100"
            } z-10 bottom-0 font-ubuntu text-white text-sm md:text-[16px]`}
          >
            <div className="font-light px-2 py-2 md:py-[17px] md:pl-[21px] md:pr-10">
              <p className="m-0">
                <b>{projectNumber}</b> Project
              </p>
              <p className="m-0">
                <b>{photos}</b> Photo
              </p>
            </div>
            {isVisible && (
              <span className="font-light leading-[18px] text-xs w-4/5 md:text-base">
                {description}
              </span>
            )}
          </div>
        </div>
      </Link>
    </section>
  )
}

export default Photo
